import React, { useMemo } from 'react';
import useStyles from './styles';
import { useGetFields } from 'src/components/modals/DealCloudV2/hooks/useGetFields';
import FilterComponent from './FilterComponent';

const DealFilterV2: React.FC = () => {
  const classes = useStyles();
  const fieldData = useGetFields();

  const filterFields = useMemo(() => {
    if (fieldData) {
      return fieldData.dealFields
        .filter((field) => field.searchOptions)
        .sort((a, b) => {
          if (a.searchOptions.order > b.searchOptions.order) {
            return 1;
          } else if (a.searchOptions.order === b.searchOptions.order) {
            return 0;
          } else if (a.searchOptions.order < b.searchOptions.order) {
            return -1;
          }
          return 0;
        });
    }
    return [];
  }, [fieldData]);

  return (
    <div className={classes.container}>
      {filterFields.map((field) => (
        <FilterComponent
          field={{
            name: field.dealCloudField.apiName,
            label: field.label,
            searchOptions: field.searchOptions,
            options: field.options ?? [],
          }}
        />
      ))}
    </div>
  );
};

DealFilterV2.displayName = 'DealFilterV2';

export default DealFilterV2;
